import axios from 'axios';

type ApiErrorResponse = {
  error?: {
    body?: {
      cause?: unknown;
      message?: string;
    };
  };
};

export function getRequestErrorMessage(
  error: unknown,
  fallback: string
): string {
  if (axios.isAxiosError(error)) {
    const body = (error.response?.data as ApiErrorResponse | undefined)?.error
      ?.body;

    if (typeof body?.cause === 'string' && body.cause.length > 0) {
      return body.cause;
    }

    if (typeof body?.message === 'string' && body.message.length > 0) {
      return body.message;
    }
  }

  if (error instanceof Error && error.message.length > 0) {
    return error.message;
  }

  return fallback;
}
